import * as React from 'react'
import { useSelector } from 'react-redux'
import { Box, Fab, CircularProgress, IconButton, Tooltip } from '@mui/material'
import { Check, Save, DeleteOutline, LockReset } from '@mui/icons-material'
import { green, red } from '@mui/material/colors'
import { updateUserById } from '../../../services'

const UserActions = ({ params, rowId, setRowId, onRequestDelete, onRequestReset }) => {
  const currentUserId = useSelector(state => state.login.authenticated?.user?.id)

  const [loading, setLoading] = React.useState(false)
  const [success, setSuccess] = React.useState(false)

  const TOKEN = `Bearer ${window.localStorage.getItem('ArbolEc_token')}`
  const isSelf = currentUserId === params.row.id

  const handleSubmit = () => {
    setLoading(true)
    const { id, nombre, apellido, email, idRol, habilitado, esPublico } = params.row
    setTimeout(async () => {
      const result = await updateUserById(
        { nombre, apellido, email, idRol, habilitado, esPublico },
        TOKEN,
        id,
      )
      if (result?.update) {
        setSuccess(true)
        setRowId(null)
      }
      setLoading(false)
    }, 1000)
  }

  React.useEffect(() => {
    if (rowId === params.id && success) setSuccess(false)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [rowId])

  return (
    <Box sx={{ m: 1, position: 'relative', display: 'flex', gap: 0.5, alignItems: 'center' }}>
      {success ? (
        <Fab
          color="primary"
          sx={{
            width: 40,
            height: 40,
            bgcolor: green[500],
            '&:hover': { bgcolor: green[700] },
          }}>
          <Check />
        </Fab>
      ) : (
        <Fab
          color="primary"
          sx={{ width: 40, height: 40 }}
          disabled={params.id !== rowId || loading}
          onClick={handleSubmit}>
          <Save />
        </Fab>
      )}
      {loading && (
        <CircularProgress
          size={52}
          sx={{ color: green[500], position: 'absolute', top: -6, left: -6, zIndex: 1 }}
        />
      )}

      <Tooltip title="Resetear contraseña">
        <IconButton
          size="small"
          onClick={() => onRequestReset(params.row)}
          sx={{ color: 'warning.main', '&:hover': { bgcolor: 'warning.light', opacity: 0.8 } }}>
          <LockReset fontSize="small" />
        </IconButton>
      </Tooltip>

      <Tooltip title={isSelf ? 'No puedes eliminar tu propia cuenta' : 'Eliminar usuario'}>
        <span>
          <IconButton
            size="small"
            disabled={isSelf}
            onClick={() => onRequestDelete(params.row)}
            sx={{
              color: isSelf ? 'action.disabled' : red[600],
              '&:hover': { bgcolor: red[50] },
            }}>
            <DeleteOutline fontSize="small" />
          </IconButton>
        </span>
      </Tooltip>
    </Box>
  )
}

export default UserActions
